import React, { useCallback, useEffect, useState } from "react";
import api, { fileUrl } from "../lib/api";
import { Link } from "react-router-dom";
import { Crown, Trophy } from "@phosphor-icons/react";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function Leaderboard() {
  const [rows, setRows] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/leaderboard/creators");
      setRows(data);
    } catch (err) {
      console.error("leaderboard load failed", err);
      setRows([]);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-[100dvh] bg-ink pb-32 px-5 pt-8" data-testid="leaderboard-page">
      <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">This week</p>
      <h1 className="text-cream text-4xl font-black tracking-tighter mt-1">Top Dance<br/>Creators</h1>
      <p className="text-cream/60 mt-3 text-sm flex items-center gap-2"><Trophy size={14} weight="fill" className="text-papaya" /> Ranked by Pearls earned in the last 7 days</p>

      {rows === null && <p className="mt-6 text-cream/40 text-sm">Loading…</p>}
      {rows && rows.length === 0 && (
        <div className="mt-8 crystal-glass rounded-3xl p-6">
          <p className="text-cream font-bold">The leaderboard is open.</p>
          <p className="text-cream/60 text-sm mt-1">Send a gift to a creator and they'll appear here. The first to receive Pearls this week wins the crown 👑</p>
        </div>
      )}

      <div className="mt-6 space-y-2" data-testid="leaderboard-list">
        {rows && rows.map((r, i) => (
          <Link
            key={r.user.id}
            to={`/u/${r.user.username}`}
            data-testid={`lb-row-${i}`}
            className={`flex items-center gap-3 p-3 rounded-2xl border transition-colors ${i === 0 ? "bg-gradient-to-r from-papaya/20 to-transparent border-papaya/40" : "bg-white/5 border-white/5 hover:border-papaya/30"}`}
          >
            <div className="w-8 text-center text-cream/60 font-black text-lg">{i < 3 ? MEDALS[i] : `#${i + 1}`}</div>
            <div className="w-12 h-12 rounded-full overflow-hidden bg-gradient-to-br from-papaya to-sea flex items-center justify-center text-ink font-black flex-shrink-0">
              {r.user.avatar_path ? <img src={fileUrl(r.user.avatar_path)} alt="" className="w-full h-full object-cover" /> : (r.user.display_name || r.user.username)[0]?.toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-cream font-bold flex items-center gap-1.5 truncate">
                {r.user.display_name}
                {i === 0 && <Crown size={14} weight="fill" className="text-papaya flex-shrink-0" />}
              </p>
              <p className="text-cream/50 text-xs">@{r.user.username} · {r.gifts_received} gifts</p>
            </div>
            <p className="text-pink-300 text-sm font-black tracking-tight">{r.pearls_this_week} 🪩</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
